<template>
  <div class="terms-and-conditions p40" style="max-width: 80%">
    <h1>Terms and Conditions for Ethos</h1>

    <p class="mt20"><strong>Last Updated: June 2026</strong></p>

    <p>
      Welcome to Ethos Empowers. These Terms and Conditions govern your access
      to and use of our website, platforms, events, competitions, learning
      programmes, and other services. By accessing our website or participating
      in our programmes, you agree to be bound by these terms.
    </p>

    <p>
      If you do not agree with any part of these terms, please discontinue use
      of our website and services.
    </p>

    <h2 class="mt20">1. Acceptance of Terms</h2>

    <p>
      By accessing our website, registering for an event, or otherwise using our
      services, you confirm that you have read, understood, and agree to these
      Terms and Conditions, along with our Privacy Policy. These terms apply to
      all visitors, users, participants, and others who access our website and
      services.
    </p>

    <h2 class="mt20">2. Eligibility</h2>

    <p>
      You must provide accurate and complete information when registering for
      events, competitions, courses, or programmes. You are responsible for
      ensuring that any information you submit is current and truthful. We
      reserve the right to refuse participation or access where information
      provided is found to be false, misleading, or incomplete.
    </p>

    <h2 class="mt20">3. Use of Our Services</h2>

    <p>By using our website and services, you agree to:</p>

    <ul>
      <li>Use our platforms only for lawful purposes</li>
      <li>
        Refrain from disrupting or interfering with the security or proper
        functioning of our website
      </li>
      <li>
        Avoid uploading or sharing content that is unlawful, harmful, offensive,
        or infringes the rights of others
      </li>
      <li>
        Not attempt to gain unauthorised access to any part of our systems or
        the data of other users
      </li>
      <li>
        Respect the rules and guidelines specific to each event, competition, or
        programme
      </li>
    </ul>

    <h2 class="mt20">4. Registrations and Participation</h2>

    <p>
      Registration for events, competitions, workshops, courses, and programmes
      is subject to the specific terms communicated for each activity. We reserve
      the right to modify, postpone, or cancel any event or programme where
      necessary.
    </p>

    <p>
      Where applicable, participation may be subject to additional rules,
      eligibility criteria, deadlines, and submission requirements. It is your
      responsibility to review and comply with these.
    </p>

    <h2 class="mt20">5. Intellectual Property</h2>

    <p>
      All content on our website, including text, graphics, logos, images,
      designs, and programme materials, is the property of Ethos Empowers or its
      partners and is protected by applicable intellectual property laws.
    </p>

    <p>
      You may not reproduce, distribute, modify, or use any of our content for
      commercial purposes without prior written permission from Ethos.
    </p>

    <h2 class="mt20">6. User-Submitted Content</h2>

    <p>
      Any content, submissions, or materials you provide as part of a
      competition, programme, or interaction with our platforms remain your
      responsibility. By submitting such content, you grant Ethos a
      non-exclusive right to use, display, and share it in connection with our
      activities, unless agreed otherwise.
    </p>

    <p>
      You confirm that any content you submit does not infringe the rights of
      third parties and complies with applicable laws.
    </p>

    <h2 class="mt20">7. Third-Party Links</h2>

    <p>
      Our website may contain links to external websites, partner platforms, or
      resources. Ethos is not responsible for the content, practices, or
      availability of these external websites. Accessing third-party links is at
      your own risk, and we encourage you to review their respective terms and
      policies.
    </p>

    <h2 class="mt20">8. Disclaimers</h2>

    <p>
      Our website and services are provided on an "as is" and "as available"
      basis. While we strive to maintain accurate, up-to-date, and reliable
      content, we make no warranties or guarantees regarding the completeness,
      accuracy, or availability of our website and services.
    </p>

    <p>
      Ethos does not guarantee that our website will be uninterrupted,
      error-free, or free of harmful components.
    </p>

    <h2 class="mt20">9. Limitation of Liability</h2>

    <p>
      To the extent permitted by law, Ethos shall not be liable for any direct,
      indirect, incidental, or consequential damages arising from your use of
      our website, participation in our programmes, or reliance on any content
      provided through our services.
    </p>

    <h2 class="mt20">10. Communication</h2>

    <p>
      By registering with Ethos or submitting your contact details, you may
      receive communications related to event registrations, competitions,
      announcements, and learning opportunities. You may opt out of promotional
      communications at any time by using the unsubscribe option provided or by
      contacting us directly.
    </p>

    <h2 class="mt20">11. Termination of Access</h2>

    <p>
      We reserve the right to suspend or terminate your access to our website or
      services, without notice, if you violate these Terms and Conditions or
      engage in conduct that we consider harmful to Ethos, its community, or
      other users.
    </p>

    <h2 class="mt20">12. Governing Law</h2>

    <p>
      These Terms and Conditions are governed by and construed in accordance with
      applicable laws. Any disputes arising in connection with these terms shall
      be subject to the appropriate jurisdiction.
    </p>

    <h2 class="mt20">13. Changes to These Terms</h2>

    <p>
      Ethos may update these Terms and Conditions periodically to reflect changes
      in our practices, technology, legal requirements, or services. Any updates
      will be published on this page with the revised date. Continued use of our
      website and services after changes are posted constitutes acceptance of the
      revised terms.
    </p>

    <h2 class="mt20">14. Contact Us</h2>

    <p>
      If you have questions, concerns, or requests regarding these Terms and
      Conditions, please contact us:
    </p>

    <p>
      Ethos Empowers<br />
      Email: info@ethosempowers.com<br />
      Website: https://ethosempowers.com
    </p>

    <p>
      We will make reasonable efforts to address your concerns and respond
      appropriately.
    </p>
  </div>
</template>

<script>
export default {
  name: "Terms"
};
</script>

<style>
.terms-and-conditions h2 {
  margin-top: 20px;
  margin-bottom: 8px;
}
</style>
